
import axios from 'axios';
import apiConfig from './apiConfig';

const apiService = axios.create({
    baseURL: apiConfig.apiUrl,
});

export async function fetchData(controller, params, token) {
    try {

        const response = await apiService.get(`/${controller}${params}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Set Authorization header
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function postData(controller, data,token) {
    try {
        const response = await apiService.post(`/${controller}`, data,{
            headers:{
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function postLogin(controller, data) {
    try {
        const response = await apiService.post(`/${controller}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
}


export async function updateData(controller, id, data,token) {
    try {
        const response = await apiService.put(`/${controller}/${id}`, data,{
            headers:{
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function deleteData(controller, id,token) {
    try {
        const response = await apiService.delete(`/${controller}/${id}`,{
            headers:{
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function activateData(controller, id,token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/activate`,null,{
            headers:{
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function CommissionData(controller, id,token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/Commission`,null,{
            headers:{
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function SyncData(controller, id,token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/update`,null,{
            headers:{
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function IncompleteData(controller, id,token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/incomplete`,null,{
            headers:{
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function SyncReprint(controller, id,userId,token) {
    try {
        const response = await apiService.put(`/${controller}/${id}/${userId}/update`,null,{
            headers:{
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Function definition (expecting id and mid)
export async function masterdataindex(controller, id, mid, token) {
    try {
        const response = await apiService.get(`/${controller}/${id}/${mid}`,{
            headers:{
                Authorization: `Bearer ${token}`, // Set Authorization header
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}



export const VerifyData = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/Verify`,null,{
            headers:{
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const PurchaseOrderDetailsDelete = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/PODetailsDelete`,null,{
            headers:{
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const ConvertPurchaseOrderToPurchase = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/ConvertPurchaseOrderToPurchase`,null,{
            headers:{
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const ConvertPurchaseOrderVerify = async (controller, id, token) => {
    try {
        const response = await apiService.put(`/${controller}/${id}/ConvertPurchaseOrderVerify`,null,{
            headers:{
                Authorization: `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};
